var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcodeOuter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134,
    height: 134,
    viewBox: "0 0 1100.000000 1100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1100.000000) scale(0.100000,-0.100000)",
    fill: "rgb(167, 31, 103)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192 10970 c-72 -36 -124 -92 -161 -169 l-26 -56 -3 -977 -2 -978 55 0 55 0 2 923 3 922 26 56 c37 79 90 133 167 171 l67 33 857 3 858 2 0 50 0 50 -918 0 -919 0 -61 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8770 10950 l0 -50 928 -2 927 -3 56 -26 c79 -37 133 -90 171 -167 l33 -67 3 -922 2 -923 55 0 55 0 -2 978 -3 977 -26 56 c-37 77 -89 133 -161 169 l-61 30 -989 0 -988 0 0 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 1203 l3 -938 26 -56 c37 -79 90 -133 167 -171 l67 -33 912 -3 913 -2 0 55 0 55 -858 2 -857 3 -67 33 c-77 38 -130 92 -167 171 l-26 56 -3 883 -2 882 -55 0 -55 0 2 -937z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10888 1258 l-3 -883 -26 -56 c-37 -79 -90 -133 -167 -171 l-67 -33 -927 -3 -928 -2 0 -55 0 -55 983 2 982 3 67 33 c77 38 130 92 167 171 l26 56 3 938 2 937 -55 0 -55 0 -2 -882z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeOuter);
export default __webpack_public_path__ + "static/media/barcodeOuter.62c795bbe124530ba4ce18029ba86680.svg";
export { ForwardRef as ReactComponent };